import {
  createRouter,
  createWebHistory,
  RouteLocationNormalized
} from 'vue-router'
import { useUserStore } from '@/stores'
import { getCurrentUser, signOutUser } from '@/modules/authentication'
import { getStorageItem } from '@/modules/native'
import { EventVisibility } from '@/modules/config'
import routes from './routes'

const isPrivateRoute = (to: RouteLocationNormalized) => {
  return to.matched.some(
    (record) =>
      typeof record.meta.visibility === 'number' &&
      record.meta.visibility > EventVisibility.Public
  )
}

const isAdminRoute = (to: RouteLocationNormalized) => {
  return to.matched.some(
    (record) =>
      typeof record.meta.visibility === 'number' &&
      record.meta.visibility === EventVisibility.Admin
  )
}

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  // Make sure we handle a pending auth redirect before anything else
  if (to.name === 'SignUp' && (await getStorageItem('authRedirect'))) {
    return next(true)
  }
  const userStore = useUserStore()
  const user = await getCurrentUser()

  userStore.auth.user = user

  if (user) {
    try {
      await userStore.initialiseUser(user.uid)
    } catch (error) {
      console.error('Failed to initialize user session:', error)
      try {
        await signOutUser()
      } catch (signOutError) {
        console.error(
          'Failed to sign out after initialization error:',
          signOutError
        )
      }
      userStore.auth.user = null
      return next({ name: 'SignUp' })
    }

    if (['SignUp', 'SignIn'].includes(to.name as string)) {
      // Disallow visiting auth routes
      next({ name: 'Home' })
    } else if (!userStore.userIsAdmin && isAdminRoute(to)) {
      next({ name: 'Home' })
    } else if (to.name === 'CreateEvent' && !userStore.userCanCreateEvents) {
      next({ name: 'Events' })
    } else next()
  } else {
    // No user found
    if (to.name === 'SignIn') {
      next()
    } else if (isPrivateRoute(to)) {
      next({ name: 'SignUp' })
    } else next()
  }
})

export default router
